import React, { useCallback, useEffect } from 'react';
import PropTypes from 'prop-types';

import SrTable from 'client/components/SrTable';

const SrDataTableUI = (props) => {
  const { dataTableViewSettings, headers, autoScrollFunction } = props;

  useEffect(() => {
    if (autoScrollFunction) {
      autoScrollFunction();
    }
  }, [props.rows, autoScrollFunction]);

  const _onHeaderClick = useCallback(
    (dataTableFieldId) => {
      if (dataTableViewSettings) {
        dataTableViewSettings.toggleSort(dataTableFieldId);
      }
    },
    [dataTableViewSettings],
  );

  const connectedHeaders = (headers || []).map((header) => ({
    ...header,
    sort: dataTableViewSettings?.sort[header.dataTableFieldId],
    onClick: !header.dataTableFieldId
      ? header.onClick
      : (...args) => {
          _onHeaderClick(header.dataTableFieldId);
          if (header.onClick) {
            header.onClick(...args);
          }
        },
  }));
  return <SrTable {...props} headers={connectedHeaders} />;
};

SrDataTableUI.displayName = 'SrDataTableUI';

SrDataTableUI.propTypes = {
  ...SrTable.propTypes,
  dataTableViewSettings: PropTypes.object,
};

SrDataTableUI.displayName = 'SrDataTableUI';

export default SrDataTableUI;
